// 1 product, 0 products, 2 products
export default function (count: number, word: string) {
  return `${count} ${word}${count == 1 ? '' : 's'}`
}
